import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

export type ClassMembershipStatus = 'pending' | 'approved' | 'rejected';

/**
 * One row per (student, class) join attempt. At most one row per pair is maintained by
 * application logic (see request-to-join-class.ts) — a rejected row is reopened to `pending`
 * on a retry rather than inserting a second row.
 */
@Entity()
export class ClassMembership extends MongoEntity {
  static override _class = 'ClassMembership';
  static override _collectionName = 'classMemberships';

  @Field(() => String)
  classRoomID!: string;

  /** The Student's `_id` — see db/student.ts. */
  @Field(() => String)
  studentID!: string;

  /** Denormalized from ClassRoom.teacherID so roster/approve/reject queries can authorize without a join. */
  @Field(() => String)
  teacherID!: string;

  @Field(() => String)
  status!: ClassMembershipStatus;

  @Field(() => String)
  requestedAt!: string;

  @Field(() => String)
  decidedAt?: string;
}
